"use strict";
exports.__esModule = true;
exports.chart_color_purple_200 = {
  "name": "--pf-v5-chart-color-purple-200",
  "value": "#8481dd",
  "var": "var(--pf-v5-chart-color-purple-200, #8481dd)"
};
exports["default"] = exports.chart_color_purple_200;